import stringUtil from './stringUtil';

const AUTH_STORAGE_KEY = 'authHeader';

export function saveAuth() {
  const auth = stringUtil.getParameterByName('authHeader');
  if (auth) {
    localStorage.setItem(AUTH_STORAGE_KEY, auth);
  }
}